export const urlConstants = {
  // BASE_URL:'http://10.202.26.14:8000',
  // BASE_URL:'http://13.251.136.133:8000',
  // BASE_URL:'http://localhost:8000',
  BASE_URL: 'http://172.31.0.236:8000/',
  // BASE_URL:'https://ec2-13-250-39-115.ap-southeast-1.compute.amazonaws.com:8443/',
  SITE_URL: '/api',
  TRENDS_URL: '/trends/',
  TRENDS_READ_CATEGORY: 'read-categories/',
  TRENDS_READ_SUBCATEGORY: 'read-sub-categories/',

  INFRA_A_URL: '/mcafee',
  TECH_A_URL: '/hips/',
  INFRA_B_URL: '/solarwinds',
  TECH_B_URL: '/sys-mgmt/',
  INFRA_C_URL: '/firemon',
  TECH_C_URL: '/security-manager/',
  INFRA_D_URL: '/symantec',
  TECH_D_URL: '/antivirus/',
  INFRA_E_URL: '/f5',
  TECH_E_URL: '/load-balancer/',
  INFRA_F_URL: '/aws',
  TECH_F_URL: '/s3/',
  TECH_G_URL: '/ec2/',
  INFRA_H_URL: '/servicenow',
  TECH_H_URL: '/cmdb/',
  TECH_I_URL: '/ticketing/',
  TECH_J_URL: '/av/',
  TECH_K_URL: '/drive-encryption/',
  TECH_L_URL: '/dlp/',
  INFRA_SYMANTEC_URL: '/symantec',
  TECH_DLP_DISCOVER_URL: '/dlp-discover/',
  TECH_DLP_ENDPOINT_URL: '/dlp-endpoint/',

  INFRA_PEOPLE_A_URL: '/people',
  TECH_PEOPLE_A_URL: '/people/',

  USECASE_COMPLIANCE: 'compliance',
  WEIGHTAGE_URL: '/smc-admin/',
  ADMIN_URL: 'admin/',
  TRENDS_WRITE_URL: 'write-tech/',
  AUTH_LOGIN_URL: '/v1/auth/login/',
  AUTH_PASSWORD_CHANGE_URL: '/v1/auth/password-change/',
  AUTH_TOKEN_VERIFY_URL: '/v1/auth/token-verify/',
  AUTH_TOKEN_REFRESH_URL: '/v1/auth/token-refresh/',

  FILTER_START_DATE: 'startDate',
  FILTER_END_DATE: 'endDate',
  'FILTER_hips-mcafee': 'system_name',
  'IMP_FILTER_hips-mcafee':',time,system_name,ip_address,',
  
  'hips-mcafee':'/mcafee/hips/',
  'av-mcafee':'/mcafee/av/',
  'antivirus-symantec':'/symantec/antivirus/',
  'dlpdiscover-symantec':'/symantec/dlp-discover/',
  'dlpendpoint-symantec':'/symantec/dlp-endpoint/',
  'firewallanalyzer-firemon':'/firemon/security-manager/',
  'dlp-symantec':'/symantec/dlp/',
  'loadbalancer-f5':'/f5/load-balancer/',
  's3-aws':'/aws/s3/',
  'ec2-aws':'/aws/ec2/',
  'monitoring-solarwinds':'/solarwinds/sys-mgmt/',
  'cmdb-servicenow':'/servicenow/cmdb/',
  'ticketing-servicenow':'/servicenow/ticketing/',
  'people-people':'/people/people/',
  'process-process':'/process/process/'
};
